/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '@angular/common';
import * as import2 from 'angular2-notifications/src/max.pipe';
import * as import3 from 'angular2-notifications/src/notification.component';
import * as import4 from 'angular2-notifications/src/notifications.service';
import * as import5 from '@angular/platform-browser';
const styles_NotificationComponent:any[] = ['\n        .simple-notification {\n            width: 100%;\n            padding: 10px 20px;\n            box-sizing: border-box;\n            position: relative;\n            float: left;\n            margin-bottom: 10px;\n            color: #fff;\n            cursor: pointer;\n            transition: all 0.5s;\n        }\n\n        .simple-notification .sn-title {\n            margin: 0;\n            padding: 0 50px 0 0;\n            line-height: 30px;\n            font-size: 20px;\n        }\n\n        .simple-notification .sn-content {\n            margin: 0;\n            font-size: 16px;\n            padding: 0 50px 0 0;\n            line-height: 20px;\n        }\n\n        .simple-notification svg {\n            position: absolute;\n            box-sizing: border-box;\n            top: 0;\n            right: 0;\n            width: 70px;\n            height: 70px;\n            padding: 10px;\n            fill: #fff;\n        }\n\n        .simple-notification.rtl-mode {\n            direction: rtl;\n        }\n\n        .simple-notification.rtl-mode .sn-content {\n            padding: 0 0 0 50px;\n        }\n\n        .simple-notification.rtl-mode svg {\n            left: 0;\n            right: auto;\n        }\n\n        .simple-notification.error { background: #F44336; }\n        .simple-notification.success { background: #8BC34A; }\n        .simple-notification.alert { background: #ffdb5b; }\n        .simple-notification.info { background: #03A9F4; }\n\n        .simple-notification .sn-progress-loader {\n            position: absolute;\n            top: 0;\n            left: 0;\n            width: 100%;\n            height: 5px;\n        }\n\n        .simple-notification .sn-progress-loader span {\n            float: left;\n            height: 100%;\n        }\n\n        .simple-notification.success .sn-progress-loader span { background: #689F38; }\n        .simple-notification.error .sn-progress-loader span { background: #D32F2F; }\n        .simple-notification.alert .sn-progress-loader span { background: #edc242; }\n        .simple-notification.info .sn-progress-loader span { background: #0288D1; }\n        .simple-notification.bare .sn-progress-loader span { background: #ccc; }\n    '];
export const RenderType_NotificationComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_NotificationComponent,
      data: {'animation': [{
        name: 'enterLeave',
        definitions: [
          {
            type: 0,
            name: 'fromRight',
            styles: {
              type: 6,
              styles: {
                opacity: 1,
                transform: 'translateX(0)'
              }

            }

          }
          ,
          {
            type: 1,
            expr: '* => fromRight',
            animation: [
              {
                type: 6,
                styles: {
                  opacity: 0,
                  transform: 'translateX(5%)'
                }

              }
              ,
              {
                type: 4,
                styles: (null as any),
                timings: '400ms ease-in-out'
              }

            ]

          }
          ,
          {
            type: 0,
            name: 'fromRightOut',
            styles: {
              type: 6,
              styles: {
                opacity: 0,
                transform: 'translateX(-5%)'
              }

            }

          }
          ,
          {
            type: 1,
            expr: 'fromRight => fromRightOut',
            animation: [
              {
                type: 6,
                styles: {
                  opacity: 1,
                  transform: 'translateX(0)'
                }

              }
              ,
              {
                type: 4,
                styles: (null as any),
                timings: '300ms ease-in-out'
              }

            ]

          }
          ,
          {
            type: 0,
            name: 'fromLeft',
            styles: {
              type: 6,
              styles: {
                opacity: 1,
                transform: 'translateX(0)'
              }

            }

          }
          ,
          {
            type: 1,
            expr: '* => fromLeft',
            animation: [
              {
                type: 6,
                styles: {
                  opacity: 0,
                  transform: 'translateX(-5%)'
                }

              }
              ,
              {
                type: 4,
                styles: (null as any),
                timings: '400ms ease-in-out'
              }

            ]

          }
          ,
          {
            type: 0,
            name: 'fromLeftOut',
            styles: {
              type: 6,
              styles: {
                opacity: 0,
                transform: 'translateX(5%)'
              }

            }

          }
          ,
          {
            type: 1,
            expr: 'fromLeft => fromLeftOut',
            animation: [
              {
                type: 6,
                styles: {
                  opacity: 1,
                  transform: 'translateX(0)'
                }

              }
              ,
              {
                type: 4,
                styles: (null as any),
                timings: '300ms ease-in-out'
              }

            ]

          }
          ,
          {
            type: 0,
            name: 'scale',
            styles: {
              type: 6,
              styles: {
                opacity: 1,
                transform: 'scale(1)'
              }

            }

          }
          ,
          {
            type: 1,
            expr: '* => scale',
            animation: [
              {
                type: 6,
                styles: {
                  opacity: 0,
                  transform: 'scale(0)'
                }

              }
              ,
              {
                type: 4,
                styles: (null as any),
                timings: '400ms ease-in-out'
              }

            ]

          }
          ,
          {
            type: 0,
            name: 'scaleOut',
            styles: {
              type: 6,
              styles: {
                opacity: 0,
                transform: 'scale(0)'
              }

            }

          }
          ,
          {
            type: 1,
            expr: 'scale => scaleOut',
            animation: [
              {
                type: 6,
                styles: {
                  opacity: 1,
                  transform: 'scale(1)'
                }

              }
              ,
              {
                type: 4,
                styles: (null as any),
                timings: '400ms ease-in-out'
              }

            ]

          }
          ,
          {
            type: 0,
            name: 'rotate',
            styles: {
              type: 6,
              styles: {
                opacity: 1,
                transform: 'rotate(0deg)'
              }

            }

          }
          ,
          {
            type: 1,
            expr: '* => rotate',
            animation: [
              {
                type: 6,
                styles: {
                  opacity: 0,
                  transform: 'rotate(5deg)'
                }

              }
              ,
              {
                type: 4,
                styles: (null as any),
                timings: '400ms ease-in-out'
              }

            ]

          }
          ,
          {
            type: 0,
            name: 'rotateOut',
            styles: {
              type: 6,
              styles: {
                opacity: 0,
                transform: 'rotate(-5deg)'
              }

            }

          }
          ,
          {
            type: 1,
            expr: 'rotate => rotateOut',
            animation: [
              {
                type: 6,
                styles: {
                  opacity: 1,
                  transform: 'rotate(0deg)'
                }

              }
              ,
              {
                type: 4,
                styles: (null as any),
                timings: '400ms ease-in-out'
              }

            ]

          }

        ]

      }
  ]}
}
);
function View_NotificationComponent_2(l:any):import0.ɵViewDefinition {
      return import0.ɵvid(0,[(l()(),import0.ɵeld(0,(null as any),(null as any),0,'div',([] as any[]),[[
        8,
        'innerHTML',
        1
      ]
  ],(null as any),(null as any),(null as any),(null as any)))],(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.safeSvg;
    ck(v,0,0,currVal_0);
  });
}
function View_NotificationComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),11,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'sn-title'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'sn-content'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import0.ɵppd(2),
    (l()(),import0.ɵted((null as any),['\n\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_NotificationComponent_2)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_2:any = (co.item.type !== 'bare');
    ck(v,10,0,currVal_2);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.item.title;
    ck(v,3,0,currVal_0);
    const currVal_1:any = import0.ɵunv(v,6,0,ck(v,7,0,import0.ɵnov((<any>v.parent),0),co.item.content,co.maxLength));
    ck(v,6,0,currVal_1);
  });
}
function View_NotificationComponent_3(l:any):import0.ɵViewDefinition {
      return import0.ɵvid(0,[(l()(),import0.ɵeld(0,(null as any),(null as any),0,'div',([] as any[]),[[
        8,
        'innerHTML',
        1
      ]
  ],(null as any),(null as any),(null as any),(null as any)))],(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.item.html;
    ck(v,0,0,currVal_0);
  });
}
function View_NotificationComponent_4(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),5,'div',[[
        'class',
        'sn-progress-loader'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import1.NgStyle,[
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
      ,{ngStyle: [
        0,
        'ngStyle'
      ]
    },(null as any)),
    import0.ɵpod(['width']),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = ck(v,4,0,(co.progressWidth + '%'));
    ck(v,3,0,currVal_0);
  },(null as any));
}
export function View_NotificationComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵpid(0,import2.MaxPipe,([] as any[])),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),12,'div',[[
        'class',
        'simple-notification'
      ]
      ],[[
        24,
        '@enterLeave',
        0
      ]
    ],[
      [
        (null as any),
        'click'
      ]
      ,
      [
        (null as any),
        'mouseenter'
      ]
      ,
      [
        (null as any),
        'mouseleave'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:import3.NotificationComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.onClick($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('mouseenter' === en)) {
        const pd_1:any = ((<any>co.onEnter()) !== false);
        ad = (pd_1 && ad);
      }
      if (('mouseleave' === en)) {
        const pd_2:any = ((<any>co.onLeave()) !== false);
        ad = (pd_2 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import1.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod([
      'alert',
      'error',
      'success',
      'info',
      'bare',
      'rtl-mode'
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_NotificationComponent_1)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_NotificationComponent_3)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_NotificationComponent_4)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n\n        '])),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(ck,v) => {
    var co:import3.NotificationComponent = v.component;
    const currVal_1:any = co.theClass;
    const currVal_2:any = ck(v,4,0,(co.item.type === 'alert'),(co.item.type === 'error'),(co.item.type === 'success'),(co.item.type === 'info'),(co.item.type === 'bare'),co.rtl);
    ck(v,3,0,currVal_1,currVal_2);
    const currVal_3:boolean = !co.item.html;
    ck(v,7,0,currVal_3);
    const currVal_4:any = co.item.html;
    ck(v,10,0,currVal_4);
    const currVal_5:any = co.showProgressBar;
    ck(v,13,0,currVal_5);
  },(ck,v) => {
    var co:import3.NotificationComponent = v.component;
    const currVal_0:any = co.item.state;
    ck(v,2,0,currVal_0);
  });
}
function View_NotificationComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'simple-notification',([] as any[]),(null as any),(null as any),(null as any),View_NotificationComponent_0,RenderType_NotificationComponent)),
    import0.ɵdid(245760,(null as any),0,import3.NotificationComponent,[
      import4.NotificationsService,
      import5.DomSanitizer,
      import0.NgZone
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const NotificationComponentNgFactory:import0.ComponentFactory<import3.NotificationComponent> = import0.ɵccf('simple-notification',import3.NotificationComponent,View_NotificationComponent_Host_0,{
  timeOut: 'timeOut',
  showProgressBar: 'showProgressBar',
  pauseOnHover: 'pauseOnHover',
  clickToClose: 'clickToClose',
  maxLength: 'maxLength',
  theClass: 'theClass',
  rtl: 'rtl',
  animate: 'animate',
  position: 'position',
  item: 'item'
}
,{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/$$_gendir/~/angular2-notifications/src/notification.component.ngfactory.ts